module.exports = __webpack_public_path__ + "static/oceanblue-2a0ea1d39385fde8d6e56a030b184409.jpeg";